import React from 'react'
import Header from '../../components/Header/Header';
import RecurringPlans from '../../components/RecurringPlans/RecurringPlans';
function RecurringPlansPage() {
  return (
    <Header activeRoute="/RecurringPlans">
      <RecurringPlans/>
    </Header>
  )
};

export default RecurringPlansPage
